import { render, staticRenderFns } from "./Hue.vue?vue&type=template&id=af8f7830&"
import script from "./Hue.vue?vue&type=script&lang=js&"
export * from "./Hue.vue?vue&type=script&lang=js&"
import style0 from "./Hue.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/usr/share/tine20/Tinebase/js/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('af8f7830')) {
      api.createRecord('af8f7830', component.options)
    } else {
      api.reload('af8f7830', component.options)
    }
    module.hot.accept("./Hue.vue?vue&type=template&id=af8f7830&", function () {
      api.rerender('af8f7830', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "node_modules/@caohenghu/vue-colorpicker/src/color/Hue.vue"
export default component.exports